import { escapeHtml } from '../lib/html.js';
import { facebookLoginUrl, importFacebookBms } from '../lib/facebook.js';
import { BM_WIZARD_STEPS, FACEBOOK_PERMISSIONS } from '../data/bm-wizard.js';

let stepIndex = 0;
let open = false;
let picker = null;

const PICK_STEPS = [
  { label: 'Facebook', hint: 'Conectado', crumb: 'ACESSO', title: 'Facebook conectado', subtitle: '' },
  {
    label: 'BMs',
    hint: 'Escolha',
    crumb: 'IMPORTAR',
    title: 'Quais BMs importar?',
    subtitle: 'Marque só as Business Managers que entram na Torre. As outras ficam de fora.',
  },
];

function wizardEl() {
  return document.getElementById('bm-wizard');
}

export function isBmWizardOpen() {
  return open;
}

function activeSteps() {
  return picker ? PICK_STEPS : BM_WIZARD_STEPS;
}

function renderSide() {
  const steps = activeSteps();
  const total = steps.length;
  const done = stepIndex;
  return `
    <p class="wizard-kicker">Progresso</p>
    <h2 class="wizard-brand">Conectar Facebook</h2>
    <p class="wizard-progress-label">${done}/${total} etapas</p>
    <div class="wizard-steps">
      ${steps.map((item, idx) => {
        const state = idx < stepIndex ? 'done' : idx === stepIndex ? 'active' : 'idle';
        return `<button type="button" class="wizard-step ${state}" data-wizard-step="${idx}">
          <span class="wizard-step-dot">${idx < stepIndex ? '✓' : idx + 1}</span>
          <span class="wizard-step-copy">
            <span class="wizard-step-label">${escapeHtml(item.label)}</span>
            <span class="wizard-step-hint">${escapeHtml(item.hint)}</span>
          </span>
        </button>`;
      }).join('')}
    </div>`;
}

function renderBars() {
  return activeSteps().map((_, idx) =>
    `<button type="button" class="wizard-bar${idx <= stepIndex ? ' on' : ''}" data-wizard-step="${idx}" aria-label="Etapa ${idx + 1}"></button>`,
  ).join('');
}

function permissionField(item) {
  return `<article class="wizard-field">
    <div class="wizard-field-head">
      <div>
        <div class="wizard-field-label">${escapeHtml(item.code)}</div>
        <span class="wizard-field-action do">vai pedir</span>
      </div>
    </div>
    <p>${escapeHtml(item.description)}</p>
  </article>`;
}

function renderBody() {
  return `
    <ol class="wizard-list">
      <li>Clique em <b>Entrar com o Facebook</b> e use a conta que administra a BM.</li>
      <li>O Meta mostra as três permissões abaixo. Aceite para a Torre ler e gerenciar os anúncios.</li>
      <li>Depois do login, marque quais BMs importar. Dá para marcar ou desmarcar todas.</li>
    </ol>
    <div class="wizard-note">
      A outra BM não precisa achar o aplicativo. Quem administra entra com o Facebook e autoriza a Torre.
    </div>
    <div class="wizard-fields">
      ${FACEBOOK_PERMISSIONS.map((item) => permissionField(item)).join('')}
    </div>`;
}

function renderFoot() {
  return `
    <span></span>
    <button type="button" class="btn btn-primary" data-wizard="next">Entrar com o Facebook</button>`;
}

function situacaoLabel(item) {
  if (item.situacao === 'conectada') return 'já conectada';
  if (item.situacao === 'em_uso') return 'em uso por outro usuário';
  const map = { verified: 'verificada', not_verified: 'não verificada', pending: 'em revisão' };
  return map[String(item.verificacao || '').toLowerCase()] || 'disponível';
}

function selecionaveis() {
  return (picker?.businesses || []).filter((item) => item.situacao === 'disponivel');
}

function renderPickerBody() {
  const livres = selecionaveis();
  const rows = (picker.businesses || []).map((item) => {
    const livre = item.situacao === 'disponivel';
    const on = livre && picker.selected.has(item.id);
    return `<label class="bm-pick${on ? ' on' : ''}${livre ? '' : ' is-off'}">
      <input class="g2-chk" type="checkbox" data-bm-id="${escapeHtml(item.id)}" ${on ? 'checked' : ''} ${livre ? '' : 'disabled'}>
      <span class="bm-pick-copy">
        <strong>${escapeHtml(item.nome)}</strong>
        <span>ID ${escapeHtml(item.id)} · ${escapeHtml(situacaoLabel(item))}</span>
        ${item.detalhe ? `<span>${escapeHtml(item.detalhe)}</span>` : ''}
      </span>
    </label>`;
  }).join('');
  const vazio = livres.length
    ? ''
    : `<div class="wizard-note">Nenhuma BM nova para importar. As que aparecem já estão conectadas ou pertencem a outro usuário.</div>`;
  return `
    <div class="bm-pick-tools">
      <button type="button" class="btn btn-ghost" data-wizard="all" ${livres.length ? '' : 'disabled'}>Marcar todas</button>
      <button type="button" class="btn btn-ghost" data-wizard="none" ${livres.length ? '' : 'disabled'}>Desmarcar todas</button>
      <span id="bm-pick-count">${picker.selected.size} de ${livres.length}</span>
    </div>
    ${picker.error ? `<p class="wizard-note">${escapeHtml(picker.error)}</p>` : ''}
    ${vazio}
    <div class="bm-pick-list">${rows}</div>`;
}

function renderPickerFoot() {
  const n = picker.selected.size;
  return `
    <button type="button" class="btn btn-ghost" data-wizard="close">Agora não</button>
    <button type="button" class="btn btn-primary" data-wizard="import" ${n && !picker.busy ? '' : 'disabled'}>${picker.busy ? 'Importando…' : `Importar ${n || ''}`.trim()}</button>`;
}

function paint() {
  const root = wizardEl();
  if (!root) return;
  const step = activeSteps()[stepIndex];
  root.querySelector('#bm-wizard-side').innerHTML = renderSide();
  root.querySelector('#bm-wizard-head').innerHTML = `
    <div class="wizard-head-row">
      <span class="wizard-crumb">${escapeHtml(step.crumb)} · etapa ${stepIndex + 1} de ${activeSteps().length}</span>
      <button type="button" class="btn btn-ghost" data-wizard="close">Cancelar</button>
    </div>
    <h3>${escapeHtml(step.title)}</h3>
    <p>${escapeHtml(step.subtitle)}</p>
    <div class="wizard-bars">${renderBars()}</div>`;
  root.querySelector('#bm-wizard-body').innerHTML = picker ? renderPickerBody() : renderBody();
  root.querySelector('#bm-wizard-foot').innerHTML = picker ? renderPickerFoot() : renderFoot();
}

export function closeBmWizard() {
  open = false;
  stepIndex = 0;
  picker = null;
  const root = wizardEl();
  if (root) root.hidden = true;
  document.getElementById('overlay')?.classList.remove('show');
}

export function openBmPicker(businesses, { onDone } = {}) {
  const list = Array.isArray(businesses) ? businesses : [];
  picker = {
    businesses: list,
    selected: new Set(list.filter((item) => item.situacao === 'disponivel').map((item) => item.id)),
    onDone,
    busy: false,
    error: '',
  };
  open = true;
  stepIndex = 1;
  const root = wizardEl();
  if (!root) return;
  root.hidden = false;
  document.getElementById('overlay')?.classList.add('show');
  paint();
}

function marcarTodas(on) {
  if (!picker || picker.busy) return;
  picker.selected = on
    ? new Set(selecionaveis().map((item) => item.id))
    : new Set();
  paint();
}

async function confirmarImportacao() {
  if (!picker || picker.busy || !picker.selected.size) return;
  picker.busy = true;
  picker.error = '';
  paint();
  try {
    const result = await importFacebookBms([...picker.selected]);
    const done = picker.onDone;
    closeBmWizard();
    await done?.(result);
  } catch (err) {
    if (!picker) return;
    picker.busy = false;
    picker.error = err.message || 'Não foi possível importar as BMs.';
    paint();
  }
}

export function openBmWizard() {
  picker = null;
  open = true;
  stepIndex = 0;
  const root = wizardEl();
  if (!root) return;
  root.hidden = false;
  document.getElementById('overlay')?.classList.add('show');
  paint();
}

function startFacebookLogin() {
  window.location.assign(facebookLoginUrl());
}

export function bindBmWizard() {
  const root = wizardEl();
  if (!root) return;
  root.addEventListener('click', (e) => {
    if (e.target === root) {
      closeBmWizard();
      return;
    }
    const closeBtn = e.target.closest('[data-wizard="close"]');
    if (closeBtn) {
      closeBmWizard();
      return;
    }
    const next = e.target.closest('[data-wizard="next"]');
    if (next) {
      startFacebookLogin();
      return;
    }
    if (e.target.closest('[data-wizard="all"]')) marcarTodas(true);
    if (e.target.closest('[data-wizard="none"]')) marcarTodas(false);
    if (e.target.closest('[data-wizard="import"]')) confirmarImportacao();
  });
  root.addEventListener('change', (e) => {
    const box = e.target.closest('[data-bm-id]');
    if (!box || !picker || picker.busy) return;
    if (box.checked) picker.selected.add(box.dataset.bmId);
    else picker.selected.delete(box.dataset.bmId);
    box.closest('.bm-pick')?.classList.toggle('on', box.checked);
    const count = root.querySelector('#bm-pick-count');
    if (count) count.textContent = `${picker.selected.size} de ${selecionaveis().length}`;
    const importBtn = root.querySelector('[data-wizard="import"]');
    if (importBtn) {
      importBtn.disabled = picker.selected.size === 0;
      importBtn.textContent = picker.selected.size ? `Importar ${picker.selected.size}` : 'Importar';
    }
  });
}
